import React, { useEffect } from "react";
import { Container } from "@mui/material";
import { useLocalStorage } from "../../hooks/useLocalStorage";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";

import Paper from "@mui/material/Paper";

import DrawerAppBar from "../../components/DrawerAppBar";
import Title from "../../components/Title";

const Messages = () => {
  const [messages] = useLocalStorage(
    "StudentWelcome",
    "messages",
    []
  );


  useEffect(() => {}, []);

  return (
    <>
      <DrawerAppBar />

      <Container sx={{ mt: 1 }}>
        <Title text="My Messages" showBack={true} />

        <TableContainer component={Paper} sx={{ mt: 2 }}>
          <Table sx={{ minWidth: 400 }} aria-label="score totals table">
            <TableBody>
              {messages.map((message) => (
                <TableRow
                  key={message.eid}
                  sx={{
                    "&:last-child td, &:last-child th": { border: 0 },
                    cursor: "pointer",
                  }}
                >
                  <TableCell>
                    <strong>ACTIVITY: {message.name}</strong><br />
                    SUBJECT: {message.subject}<br />
                    MESSAGE: {message.message}<br />
                  </TableCell>
                </TableRow>
              ))}
              {messages.length === 0 && (
                <TableRow>
                  <TableCell colSpan={5}>-- NO MESSAGES --</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Container>
    </>
  );
};

export default Messages;
